module.exports = __webpack_public_path__ + "img/SKWINKELNetActieKPIE2A637.80307abd.png";